import React, { useState } from "react";
import SelectComponent from "../../Sales CRM/SelectComponent"; // Adjust the import path as needed
let num = 0;
function SupportTicketFilterComp({
  leadPipelineOptions,
  businessCategoryOptions,
  onFilterChange,
}) {
  const [filterByLeadPipeline, setFilterByLeadPipeline] = useState([]);
  const [filterByBusinessCategory, setFilterByBusinessCategory] = useState([]);

  const handleCheckboxChange1 = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilterByLeadPipeline(values);
    onFilterChange && onFilterChange({ filterByLeadPipeline: values });
  };

  const handleCheckboxChange2 = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    const id = selectedOptions
      ? selectedOptions.map((option) => option.id)
      : [];
    //setFilterByLeadPipeline(values);
    setFilterByBusinessCategory(values);
    onFilterChange && onFilterChange({ filterByBusinessCategory: id });

    // onFilterChange && onFilterChange({ filterByBusinessCategory: values });
  };

  return (
    <>
      <SelectComponent
        label="KAM Tier \ Support"
        options={leadPipelineOptions}
        handleSelectChange={handleCheckboxChange1}
        selectedOptions={filterByLeadPipeline}
      />

      <SelectComponent
        label="KAM Executive name"
        options={businessCategoryOptions}
        handleSelectChange={handleCheckboxChange2}
        selectedOptions={filterByBusinessCategory}
      />
    </>
  );
}

export default SupportTicketFilterComp;
